module.exports = __webpack_public_path__ + "media/images/badges/yogasix/inactive/Y6Warrior2022_Badges_5500_Inactive@1x-514ee0f74637096f38abee4b94fe4dcd.png";